export default {
  region: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_Ong4pBWzR',
  cognitoUserPoolWebClientId: '6r8dsvv87esbue2q301b24s29',
  cognitoIdentityPoolId: 'us-east-1:f12098be-2a1a-455d-93eb-aead0b76eeed',
  cognitoDomain: 'pv-mme-dynamic-ads-manviag.auth.us-east-1.amazoncognito.com',
  redirectSignIn: 'https://manviag.personal.dynamic-ads.video.amazon.dev/auth-callback',
  redirectSignOut: 'https://manviag.personal.dynamic-ads.video.amazon.dev/',
  apiServerBaseUrl: 'https://api.manviag.personal.dynamic-ads.video.amazon.dev',
  stage: 'personal',
  benderApiServerBaseUrl: 'https://api.beta.bender.dynamic-ads.video.amazon.dev',
  fryApiServerBaseUrl: 'https://api.beta.fry.dynamic-ads.video.amazon.dev',
  loggerBaseUrl: 'https://logger.manviag.personal.dynamic-ads.video.amazon.dev/{proxy+}',
  monitoringBaseUrl: 'https://monitoring.manviag.personal.dynamic-ads.video.amazon.dev/{proxy+}',
  featureFlags: 'enableReportingDashboard,enableBlocklist,enableAbTesting,enableSpotlightLal,enablePublisherConfigs,enablePublisherConfigCampaignForm',
  spotlightApiGatewayBaseUrl: 'https://beta.spotlight.video.amazon.dev',
  productsBucketName: '',
  mediaBucketName: 'leela-media-424683028875-us-east-1-personal',
  agentCoreWsUrl: 'wss://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn:aws:bedrock-agentcore:us-east-1:424683028875:runtime/leela_agent_orchestrator_personal-dP2GwKCxKN/ws',
};
